(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.MapSidebar = (function() {
    function MapSidebar(map, element, tabs) {
      if (map == null) {
        map = null;
      }
      if (element == null) {
        element = null;
      }
      if (tabs == null) {
        tabs = true;
      }
      this.resizeContent = bind(this.resizeContent, this);
      this.resizeMap = bind(this.resizeMap, this);
      this.toggle = bind(this.toggle, this);
      this.messageWriter = bind(this.messageWriter, this);
      this.contentDiv = bind(this.contentDiv, this);
      this.map = map;
      if (!element) {
        element = $($('.map_sidebar')[0]);
      }
      this.element = element;
      this.isOpen = true;
      this.openLeft = 0;
      this.closeLeft = -298;
      this.element.find('.map_sidebar_hide').click((function(_this) {
        return function() {
          return _this.toggle();
        };
      })(this));
      if (tabs) {
        this.element.delegate('.nav-tabs a', 'click', function(e) {
          var handler, sub;
          if ($(this).attr('ui-sref')) {
            return;
          }
          e.preventDefault();
          $(this).tab('show');
          handler = $(this).data('handler') || $(this).html();
          sub = App.current_page.createSubHandler(handler);
          if (sub) {
            return sub.init();
          }
        });
      }
      $(window).on('resize', debounce((function(_this) {
        return function() {
          return _this.resizeContent(false);
        };
      })(this)));
    }

    MapSidebar.prototype.contentDiv = function() {
      return this.element.find('.sidebar_content');
    };

    MapSidebar.prototype.messageWriter = function() {
      var elem;
      elem = this.element.find('.sidebar_message_writer');
      if (elem.length > 0) {
        elem.message_writer();
      }
      return elem;
    };

    MapSidebar.prototype.toggle = function() {
      var icon, left;
      left = this.isOpen ? this.closeLeft : this.openLeft;
      icon = this.isOpen ? 'fa fa-chevron-right' : 'fa fa-chevron-left';
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.contentDiv().parent().css('display', 'block');
      }
      this.element.animate({
        marginLeft: left + "px"
      }, {
        duration: 200,
        step: (function(_this) {
          return function() {
            _this.resizeMap(left);
            return _this.resizeContent();
          };
        })(this),
        complete: (function(_this) {
          return function() {
            _this.resizeMap(left);
            _this.resizeContent();
            if (!_this.isOpen) {
              return _this.contentDiv().parent().css('display', 'none');
            }
          };
        })(this)
      });
      return this.element.find('.map_sidebar_hide').find('i').attr('class', icon);
    };

    MapSidebar.prototype.open = function() {
      if (!this.isOpen) {
        return this.toggle();
      }
    };

    MapSidebar.prototype.close = function() {
      if (this.isOpen) {
        return this.toggle();
      }
    };


    /*
     *
     * This function ensures correct sizing for map and sidebar.
     * When the window is resized or the sidebar is toggled, we need to
     * fix several things, including a lot of height settings, and the width/placement
     * of the map canvas
     *
     */

    MapSidebar.prototype.resizeMap = function(left_margin) {
      var effectiveWidth, sidebarLeftOffset, sidebarWidth;
      if (this.map == null) {
        return;
      }
      sidebarWidth = this.element.outerWidth(true);
      sidebarLeftOffset = this.element.offset().left;
      effectiveWidth = sidebarWidth + sidebarLeftOffset;
      $('#map_canvas').css({
        left: effectiveWidth + 'px',
        right: '0px'
      });
      this.map.invalidateSize();
    };


    /*
     *
     * This function ensures correct sizing for fullpage content and sidebar.
     * We want to acuatlly resize the fullpage content instead of just shifting
     * it to the left.
     *
     */

    MapSidebar.prototype.resizeContent = function(triggerWindowResize) {
      var effectiveWidth, fullpage_content, sidebarLeftOffset, sidebarWidth, window_width;
      if (triggerWindowResize == null) {
        triggerWindowResize = true;
      }
      if (this.element.is(':hidden')) {
        return;
      }
      fullpage_content = $('#map_fullpage').first();
      if (fullpage_content == null) {
        return;
      }
      sidebarWidth = this.element.outerWidth(true);
      sidebarLeftOffset = this.element.offset().left;
      effectiveWidth = sidebarWidth + sidebarLeftOffset;
      window_width = $(window).width();
      fullpage_content.width(window_width - effectiveWidth).css({
        left: effectiveWidth + 'px'
      });
      if (triggerWindowResize) {
        setTimeout((function(_this) {
          return function() {
            return $(window).trigger('resize');
          };
        })(this), 0);
      }
    };

    return MapSidebar;

  })();

}).call(this);
